export default {
  name: "App"
};
